import config from '../config';

const API_URL = config.API_URL;

class KitsService {
  /**
   * Récupérer tous les kits
   */
  async getAllKits() {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/kits`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des kits');
    }

    return await response.json();
  }

  /**
   * Récupérer un kit spécifique
   */
  async getKit(kitId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/kits/${kitId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération du kit');
    }

    return await response.json();
  }

  /**
   * Créer un nouveau kit
   */
  async createKit(kitData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kits`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(kitData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la création du kit');
    }

    return await response.json();
  }

  /**
   * Mettre à jour un kit
   */
  async updateKit(kitId, kitData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kits/${kitId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(kitData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la mise à jour du kit');
    }

    return await response.json();
  }

  /**
   * Supprimer un kit
   */
  async deleteKit(kitId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kits/${kitId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la suppression du kit');
    }

    return await response.json();
  }

  /**
   * Ajouter une catégorie à un kit
   */
  async addCategory(kitId, categoryData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kits/${kitId}/categories`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de l\'ajout de la catégorie');
    }

    return await response.json();
  }

  /**
   * Supprimer une catégorie d'un kit
   */
  async removeCategory(kitId, categoryId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kits/${kitId}/categories/${categoryId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la suppression de la catégorie');
    }

    return await response.json();
  }

  /**
   * Ajouter un produit à une catégorie
   */
  async addProductToCategory(categoryId, productData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kit-categories/${categoryId}/products`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de l\'ajout du produit');
    }

    return await response.json();
  }

  /**
   * Ajouter une remise à une catégorie
   */
  async addDiscountToCategory(categoryId, discountData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kit-categories/${categoryId}/discounts`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(discountData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de l\'ajout de la remise');
    }

    return await response.json();
  }

  /**
   * Supprimer un produit d'une catégorie
   */
  async removeProductFromCategory(categoryId, productId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kit-categories/${categoryId}/products/${productId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la suppression du produit');
    }

    return await response.json();
  }

  /**
   * Supprimer une remise d'une catégorie
   */
  async removeDiscountFromCategory(categoryId, discountId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/kit-categories/${categoryId}/discounts/${discountId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la suppression de la remise');
    }

    return await response.json();
  }
}

export default new KitsService();







